<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text" #titleTextBox [value]="title" id="titleTextBox"
                (blur)="closeTextbox($event.target)" (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
        </div>
        <div class="transaction-section-header-actions header-actions">


          @if (_hasFieldControlLicense) {
            <button [class.ViewModeHiddenElement]="_pageState != 2" class="hidden-xs asap-btn" kendoButton
              (click)="_editFormState()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
              </span>Edit Form
            </button>
          }

          @if (_hasFieldControlLicense) {
            <button [class.ViewModeHiddenElement]="_pageState != 4" class="hidden-xs asap-btn" kendoButton
              (click)="_returnAddNew()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
              </span>Close Edit Form
            </button>
          }

          <button class="hidden-xs asap-btn" kendoButton (click)="_ValidationAndSave($event)">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
            </span>Process
          </button>



          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
            </span>Clear
          </button>
          <!-- <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
          <span><img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>Save
        </button> -->
      </div>
    </div>
  </div>
</div>
<div class="row no-row-margin">
  <div class="col-12 col-lg-6 small-pad-right">
    <div class="transactionWidget">
      <div class="row">
        <div class="col-12">
          <p class="titleStandardStyle">General Information</p>
        </div>
        @if (getAuthByLabel('LBL_ReceiveDateTime')?.canView) {
          <div class="col-12 margin-top-10">
          </div>
        }

        <div class="col-12">
          <div class="form-group special_style_formgroup">
            <div class="row">
              <div class="col-2">
                <label class="control-label">Date - Time</label>
              </div>
              <div class="col-10 transaction-receive-input-fields">
                <kendo-datetimepicker formControlName="date" placeholder="Set Date and Time"
                  class="k-datepicker datepickerControlrightMargin"
                  [attr.required]="getLabel('LBL_ReceiveDateTime')?.isRequired ? 'required' : null"
                  [disabled]="!_dateEnabled" [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ReceiveDateTime')?.isRequired)}"
                  [format]="_datePickerFormat">
                </kendo-datetimepicker>
              </div>
            </div>
            <div class="transactions-receive-stock-right-checkbox empty-small"></div>
          </div>
        </div>

        <sites-dropdown #kendo_combo_sites layout="transaction" [forceShow]="_isMultiSiteSelected"
          [labelText]="'Site'" [inputContainerClass]="'transaction-receive-input-fields'" formControlName="site"
          [placeholder]="'Choose a Site'" [textField]="'code'" [valueField]="'id'" [class]="'bordered current-step'"
          [required]="true" [showAllSites]="false" (siteChanged)="onSitesChange($event)">
        </sites-dropdown>
        @if (_hasPurchaseOrderLicense && getAuthByLabel('LBL_ReceivePO')?.canView) {
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">{{getLabel('LBL_ReceivePO')?.text}}</label>
                </div>
                @if (_poPreference != 'notValidated') {
                  <div class="col-10 transaction-receive-input-fields">
                    <kendo-combobox #kendo_combo_purchaseorders [data]="_purchaseOrdersFiltered" [filterable]="true"
                      (filterChange)="_handlePurchaseOrdersFilter($event)"
                      (selectionChange)="_handlePurchaseOrdersSelection($event)" [suggest]="true"
                      formControlName="purchaseOrder" [placeholder]="'Choose a PO#'" [textField]="'poNumber'"
                      [valueField]="'id'" class="" (valueChange)="poValueChange($event)"
                      [attr.disabled]="getAuthByLabel('LBL_ReceivePO')?.canEdit ? null : 'disabled'"
                      [attr.required]="getLabel('LBL_ReceivePO')?.isRequired ? 'required' : null"
                      [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ReceivePO')?.isRequired)}">
                    </kendo-combobox>
                    @if (_purchaseOrderAuth?.canAdd) {
                      <a class="cursor-pointer" (click)="_openForm('purchaseOrders')">
                        <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                      </a>
                    }
                    <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                      (click)="_openRenameForm('LBL_ReceivePO')">
                      <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                    </a>
                  </div>
                }
                @if (_poPreference == 'notValidated') {
                  <div class="col-10 transaction-receive-input-fields">
                    <input type="text" class="k-textbox writebox" formControlName="purchaseOrder"
                      placeholder="Type a PO#" />
                    </div>
                  }
                </div>
                <div class="transactions-receive-stock-right-checkbox empty-small"></div>
              </div>
            </div>
          }
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">{{getLabel('LBL_ReceiveLocation')?.text}}</label>
                </div>
                <div kendoTooltip class="col-10 transaction-receive-input-fields">
                  <kendo-combobox #kendo_combo_locations [disabled]="_defaultLocationSettingEnabled == true"
                    [data]="_locationsFiltered" [filterable]="true" (filterChange)="_handleLocationsFilter($event)"
                    [suggest]="true" (valueChange)="locationValueChange($event)" formControlName="location"
                    [placeholder]="'Choose a Location'" [textField]="'code'" [valueField]="'id'" class="bordered"
                    required>
                  </kendo-combobox>
                  <!-- Add -->
                  @if (_locationAuth?.canAdd) {
                    <a title="Add {{getLabel('LBL_ReceiveLocation')?.text}}"
                      class="cursor-pointer" [class.disabled]=" _defaultLocationSettingEnabled == true"
                      (click)="_openForm('locations')">
                      <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                    </a>
                  }
                  <!-- Select -->
                  <span class="asap-input-icon">
                    <img class="addIcon" (click)="_selectLocationsHandler()"
                      [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                    </span>
                  </div>
                </div>
                <div class="transactions-receive-stock-right-checkbox empty-small"></div>
              </div>
            </div>

            @if (getAuthByLabel('LBL_ReceiveVendor')?.canView) {
              <div class="col-12">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <label class="control-label">{{getLabel('LBL_ReceiveVendor')?.text}}</label>
                    </div>
                    <div class="col-10 transaction-receive-input-fields">
                      <kendo-combobox #kendo_combo_vendors
                        [disabled]="(_form.get('purchaseOrder').value != null && _poPreference == 'full')"
                        [data]="_vendorsFiltered" [filterable]="true" (filterChange)="_handleVendorsFilter($event)"
                        [suggest]="true" formControlName="vendor" [placeholder]="'Choose a Vendor'"
                        (valueChange)="vendorValueChange($event)" [textField]="'code'" [valueField]="'id'"
                        [attr.disabled]="getAuthByLabel('LBL_ReceiveVendor')?.canEdit ? null : 'disabled'"
                        [attr.required]="getLabel('LBL_ReceiveVendor')?.isRequired ? 'required' : null"
                        [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ReceiveVendor')?.isRequired)}">
                      </kendo-combobox>
                      @if (_vendorAuth?.canAdd) {
                        <a class="cursor-pointer"
                          [class.disabled]="(_form.get('purchaseOrder').value != null && _poPreference == 'full')"
                          (click)="_openForm('vendors')">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                        </a>
                      }
                      <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                        (click)="_openRenameForm('LBL_ReceiveVendor')">
                        <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                      </a>
                      <!-- Select -->
                      <span class="asap-input-icon" style="position: absolute">
                        <img class="addIcon"
                          [class.disabled]="(_form.get('purchaseOrder').value != null && _poPreference == 'full')"
                          (click)="_selectVendorsHandler()" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                        </span>
                      </div>
                    </div>
                    <div class="transactions-receive-stock-right-checkbox empty-small"></div>
                  </div>
                </div>
              }

              @if (getAuthByLabel('LBL_ReceiveTransactionNote')?.canView) {
                <div Quantity class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2">
                        <label class="control-label">{{getLabel('LBL_ReceiveTransactionNote')?.text}}</label>
                      </div>
                      <div kendoTooltip class="col-10 transaction-receive-input-fields">
                        <input type="text" class="k-textbox writebox" placeholder="Transaction Notes.." formControlName="note"
                          [attr.disabled]="getAuthByLabel('LBL_ReceiveTransactionNote').canEdit ? null : 'enabled'"
                          [attr.required]="getLabel('LBL_ReceiveTransactionNote')?.isRequired ? 'required' : null" />
                          <a title="Edit {{getLabel('LBL_ReceiveTransactionNote')?.text}}"
                            [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                            (click)="_openRenameForm('LBL_ReceiveTransactionNote')">
                            <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                          </a>
                        </div>
                      </div>
                      <div class="transactions-receive-stock-right-checkbox empty-small"></div>
                    </div>
                  </div>
                }
                <!-- UDHeaderField1 -->
                @if (_receiveUDHeaderField1Show) {
                  <div class="col-12">
                    <div class="form-group special_style_formgroup">
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">{{_receiveUDHeaderField1Name || 'UDHeaderField1'}}</label>
                        </div>
                        <div class="col-10 transaction-receive-input-fields">
                          <input type="text"
                            id="udHeaderField1"
                            class="k-textbox writebox"
                            formControlName="udHeaderField1"
                            [placeholder]="_receiveUDHeaderField1Name || 'UDHeaderField1'"
                            [disabled]="_pageState == 4" />
                          </div>
                        </div>
                        <div class="transactions-receive-stock-right-checkbox empty-small"></div>
                      </div>
                    </div>
                  }
                  <!-- UDHeaderField2 -->
                  @if (_receiveUDHeaderField2Show) {
                    <div class="col-12">
                      <div class="form-group special_style_formgroup">
                        <div class="row">
                          <div class="col-2">
                            <label class="control-label">{{_receiveUDHeaderField2Name || 'UDHeaderField2'}}</label>
                          </div>
                          <div class="col-10 transaction-receive-input-fields">
                            <input type="text"
                              id="udHeaderField2"
                              class="k-textbox writebox"
                              formControlName="udHeaderField2"
                              [placeholder]="_receiveUDHeaderField2Name || 'UDHeaderField2'"
                              [disabled]="_pageState == 4" />
                            </div>
                          </div>
                          <div class="transactions-receive-stock-right-checkbox empty-small"></div>
                        </div>
                      </div>
                    }
                    <!-- UDHeaderField3 -->
                    @if (_receiveUDHeaderField3Show) {
                      <div class="col-12">
                        <div class="form-group special_style_formgroup">
                          <div class="row">
                            <div class="col-2">
                              <label class="control-label">{{_receiveUDHeaderField3Name || 'UDHeaderField3'}}</label>
                            </div>
                            <div class="col-10 transaction-receive-input-fields">
                              <input type="text"
                                id="udHeaderField3"
                                class="k-textbox writebox"
                                formControlName="udHeaderField3"
                                [placeholder]="_receiveUDHeaderField3Name || 'UDHeaderField3'"
                                [disabled]="_pageState == 4" />
                              </div>
                            </div>
                            <div class="transactions-receive-stock-right-checkbox empty-small"></div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6 small-pad-left">
                  <div class="transactionWidget">
                    <div class="row">
                      <div class="col-12">
                        <p class="titleStandardStyle">Scan Stock Items#</p>
                      </div>

                      <div class="col-12 margin-top-10">
                        <div class="form-group special_style_formgroup display-flex">
                          <div class="row flex-1">
                            <div class="col-2">
                              <label class="control-label">Stock Item#</label>
                            </div>
                            <div class="col-9 ml-1 transaction-receive-input-fields">

                              <kendo-combobox #kendo_combo_items class="bordered current-step newFormControlWidth"
                                [data]="_itemsFilteredNew" [suggest]="true" [filterable]="true" [placeholder]="'Stock Item#'"
                                id="number" name="number" [formControl]="_selectedStockItem" [textField]="'number'"
                                [valueField]="'id'" (valueChange)="_handleItemsChange($event)"
                                (filterChange)="_handleItemsFilterDropDownPaging($event)"
                                (opened)="scrollComboboxNew($event); _onStockItemDropdownOpened()"
                                [disabled]="this.porderid > 0 && this._poPreference == 'full' && this._deletedPOItems.length === 0"
                                [attr.disabled]="this.porderid > 0 && this._poPreference == 'full' && this._deletedPOItems.length === 0"
                                required>
                                <ng-template kendoDropDownListNoDataTemplate>
                                  <div class="stocksettEnabledContainer">
                                    @if (!_addNewStockSettingEnabled) {
                                      <span class="missing-item-txt">
                                        No data found.<br />
                                      </span>
                                    }
                                    @if (_addNewStockSettingEnabled) {
                                      <span class="missing-item-txt">Missing Item!</span><br />
                                      <span class="stocksettEnabledContainer-boldtxt">Stock Item# "{{ _itemFilter }}"</span>
                                      does not exist. Do you want to add it?<br />
                                      By clicking
                                      <span class="stocksettEnabledContainer-boldtxt">"Add"</span>
                                      Stock Item # {{ _itemFilter }} will be automatically
                                      added.
                                    }
                                    <br />
                                    @if (_addNewStockSettingEnabled) {
                                      <div class="action-button action-button-add action-button-small"
                                        (click)="_openForm('stockItems')">
                                        <div class="action-button-icon">
                                          <img src="/assets/menu/enterprise/add-icon-green.svg" />
                                        </div>
                                        <div class="edit-icon-text">Add</div>
                                      </div>
                                    }
                                    @if (_addNewStockSettingEnabled) {
                                      <div class="action-button action-button-skip action-button-small"
                                        (click)="_skipAddNewStock()">
                                        <div class="action-button-icon">
                                          <img src="/assets/menu/enterprise/minus-icon-gray.svg" />
                                          <!-- rise/add-new-icon_grid.svg -->
                                        </div>
                                        <div class="edit-icon-text">Skip</div>
                                      </div>
                                    }
                                  </div>
                                </ng-template>
                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                  <div class="transactions-receive-stock-dropdown-item">
                                    <div class="truncate">{{ dataItem?.number }}</div>
                                    <div class="transactions-receive-stock-dropdown-item-description truncate">
                                      @if (dataItem?.description) {
                                        <span>| {{ dataItem?.description }}</span>
                                      }
                                    </div>
                                  </div>
                                </ng-template>
                              </kendo-combobox>
                              <!-- Add -->
                              @if (_addNewStockSettingEnabled) {
                                <a title="Add New Stock Item" class="cursor-pointer"
                                  (click)="_openForm('stockItems')">
                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                </a>
                              }
                              <!-- Fetch / Select-->
                              <span class="asap-input-icon">
                                <img class="addIcon" (click)="_selectStocksHandler()"
                                  [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'"
                                  [class.disabled]="this.porderid > 0 && this._poPreference == 'full' && this._deletedPOItems.length === 0" />
                                </span>
                              </div>
                            </div>
                            <!-- Old Print Receipt Location-->
                            <!-- <div
                            class="transactions-receive-stock-right-checkbox noprint"
                            [class.notempty]="_settingsPrintReceipt && _settingsPrintReceipt.enabled"
                            >
                            <input
                              type="checkbox"
                              class="k-checkbox"
                              kendoCheckBox
                              [formControl]="_printReceipt"
                              *ngIf="_settingsPrintReceipt && _settingsPrintReceipt.enabled"
                              />
                              <div
                                class="transactions-receive-stock-right-checkbox-text"
                                *ngIf="_settingsPrintReceipt && _settingsPrintReceipt.enabled"
                                >
                                Print Receipt
                              </div>
                            </div> -->

                            <div class="transactions-receive-stock-right-checkbox">
                              @if (_printLabelsSettingsEnabled) {
                                <input type="checkbox" class="k-checkbox" kendoCheckBox [formControl]="_printLabel"
                                  (change)="_checkLabel($event)" />
                                  <div class="transactions-receive-stock-right-checkbox-text">
                                    Print Label
                                  </div>
                                  @if (_printLabel.value) {
                                    <div class="OptionsLeftMargin">
                                      <div class="labelQty">
                                        <input type="radio" class="adminRadio" name="label" kendoRadioButton
                                          style="width: 10px; height: 10px" [checked]="_isOneLineItem" value="line"
                                          (change)="_lineQtyChange($event)" />
                                          1/line item
                                        </div>
                                        <div class="labelQty">
                                          <input type="radio" class="adminRadio" name="label" kendoRadioButton
                                            style="width: 10px; height: 10px" [checked]="!_isOneLineItem" value="qty"
                                            (change)="_lineQtyChange($event)" />
                                            Qty/line item
                                          </div>
                                        </div>
                                      }
                                    }
                                  </div>
                                </div>

                                <div class="form-group special_style_formgroup display-flex">
                                  <div class="row flex-1">
                                    <div class="col-2">
                                      <label class="control-label">Receive Quantity</label>
                                    </div>
                                    <div class="col-9 ml-1 transaction-receive-input-fields">
                                      <kendo-numerictextbox #quantity_input class="k-textbox writebox" [min]="0"
                                        [class.disabled]="this.porderid > 0 && this._poPreference == 'full'" [autoCorrect]="autoCorrect"
                                        [formControl]="_quantity" (keyup.enter)="_quantitySubmitted()" format="{{ quantityFormat }}"
                                      (keydown.Tab)="_quantitySubmitted()"></kendo-numerictextbox>
                                    </div>
                                  </div>

                                  <div class="transactions-receive-stock-right-checkbox">
                                    <input type="checkbox" class="k-checkbox" [formControl]="_defaultQuantity"
                                      [class.disabled]="this.porderid > 0 && this._poPreference == 'full'" kendoCheckBox />
                                      <div class="transactions-receive-stock-right-checkbox-text">
                                        Set as Default
                                      </div>
                                    </div>
                                  </div>

                                  <div class="section-separator"></div>
                                </div>

                                <div class="col-12">
                                  <div class="form-group special_style_formgroup display-flex">
                                    <div class="row flex-1">
                                      <div class="col-2">
                                        <label class="control-label"
                                          [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'">
                                          Inventory ID#
                                        </label>
                                      </div>
                                      <div class="col-9 ml-1 transaction-receive-input-fields">
                                        <input #inventory_id type="text" class="k-textbox writebox"
                                          [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'"
                                          [placeholder]="'Inventory ID#'" [formControl]="_inventoryCode" [value]="_inventoryCode"
                                          (change)="_inventoryCodeChanged()" (keydown)="_inventoryCodeChanged()"
                                          (keyup.enter)="_quantitySubmitted(_inventoryCode)"
                                          (keydown.Tab)="_quantitySubmitted(_inventoryCode)" required />
                                          <a class="cursor-pointer"
                                            [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'"
                                            (click)="_generateBarcodeClick()">
                                            <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                          </a>
                                        </div>
                                      </div>

                                      <div class="transactions-receive-stock-right-checkbox">
                                        <input type="checkbox" class="k-checkbox" [formControl]="_autoCodeGeneration"
                                          [class.disabled]="this.porderid > 0 && this._poPreference == 'full'" kendoCheckBox />
                                          <div class="transactions-receive-stock-right-checkbox-text">
                                            Auto Generate
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12">
                                      <div class="form-group special_style_formgroup display-flex">
                                        <div class="row flex-1">
                                          <div class="col-2">
                                            <label class="control-label"
                                            [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory'">Expiration Date</label>
                                          </div>
                                          <div class="col-9 ml-1 transaction-receive-input-fields">
                                            <kendo-datetimepicker #expiration_date class="k-datepicker" [formControl]="_expirationDate"
                                              [min]="_minDate"
                                              [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory' || (this.porderid > 0 && this._poPreference == 'full')"
                                              placeholder="Choose Date" (valueChange)="_dateChanged($event)"
                                              [formatPlaceholder]="_dateFormatlabel" (keyup.enter)="_quantitySubmitted()"
                                              [format]="_datePickerFormat" (focus)="addFocusClassToExpirationDate($event)">


                                            </kendo-datetimepicker>
                                            <!-- <span  [ngClass]="{'ShowSkip': ShowSkip === true}"
                                            class="datepickerSkipButton"
                                            >
                                            <div (click)="_quantitySubmitted(true)">skip<img
                                              [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'"
                                              />
                                            </div>
                                          </span> -->

                                        </div>
                                      </div>

                                      <div class="transactions-receive-stock-right-checkbox">
                                        <input type="checkbox" class="k-checkbox" [formControl]="_defaultDate"
                                          [class.disabled]="this.porderid > 0 && this._poPreference == 'full'" kendoCheckBox />
                                          <div class="transactions-receive-stock-right-checkbox-text">
                                            Set as Default
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12">
                                      <div class="form-group special_style_formgroup display-flex upload-file">
                                        <div class="row flex-1">
                                          <div class="col-2">
                                            <label class="control-label"> Attached Document </label>
                                          </div>
                                          <!-- [saveUrl]="uploadSaveUrl"
                                          [removeUrl]="uploadRemoveUrl" -->
                                          <div #kendo_uploader_wrapper class="col-9 ml-1 combobox_contaainer">
                                            <kendo-upload [class.active]="true" [class.disabled]="false" #kendo_uploader [batch]="false"
                                              [autoUpload]="false" [multiple]="true" class="NextToLabelUpload requiredDropZone"
                                              (select)="_fileSelectedChanges($event)" (remove)="_fileRemoveEventHandler($event)"
                                              formControlName="stream">
                                              <!-- formControlName="stream" -->
                                              <kendo-upload-messages [select]="_uploaderSelectMessage" [dropFilesHere]="''">
                                              </kendo-upload-messages>
                                            </kendo-upload>

                                            <!-- <div class="col-2 text-left"> -->
                                            <!-- <a
                                            class="cursor-pointer text-left search"
                                            (click)="_showDocumentsGrid=true"
                                            >
                                            <img
                                              class="searchIcon"
                                              [src]="'/assets/menu/'+ _theme +'/search-icon.svg'"
                                            /></a> -->
                                          <!-- </div> -->
                                          <span class="picture-form-external-upload-btn" (click)="_onUploadClick()">
                                            <img [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                          </span>
                                          <a (click)="_showDocumentsGrid=true" class="asap-input-icon"><img _ngcontent-sqy-c791=""
                                          class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'"></a>

                                        </div>

                                      </div>
                                      <!-- <div class="PO-stock-right-checkbox empty"></div>
                                      <div class="PO-stock-right-checkbox empty"></div> -->
                                    <!-- </div> -->
                                    <!-- <div class="col-2 p-0"> -->
                                    <!--Old Print Label Position-->
                                    <!-- <div class="transactions-receive-stock-right-checkbox">
                                    <ng-container *ngIf="_printLabelsSettingsEnabled">
                                      <input
                                        type="checkbox"
                                        class="k-checkbox"
                                        kendoCheckBox
                                        [formControl]="_printLabel"
                                        (change)="_checkLabel($event)"
                                        />
                                        <div class="transactions-receive-stock-right-checkbox-text">
                                          Print Label
                                        </div>
                                        <div *ngIf="_printLabel.value">
                                          <div class="labelQty">
                                            <input
                                              type="radio"
                                              class="adminRadio"
                                              name="label"
                                              kendoRadioButton
                                              style="width: 10px; height: 10px"
                                              [checked]="_isOneLineItem"
                                              value="line"
                                              (change)="_lineQtyChange($event)"
                                              />
                                              1/line item
                                            </div>
                                            <div class="labelQty">
                                              <input
                                                type="radio"
                                                class="adminRadio"
                                                name="label"
                                                kendoRadioButton
                                                style="width: 10px; height: 10px"
                                                [checked]="!_isOneLineItem"
                                                value="qty"
                                                (change)="_lineQtyChange($event)"
                                                />
                                                Qty/line item
                                              </div>
                                            </div>
                                          </ng-container>
                                        </div> -->
                                        <div class="transactions-receive-stock-right-checkbox noprint"
                                          [class.notempty]="_settingsPrintReceipt && _settingsPrintReceipt.enabled">
                                          @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                                            <input type="checkbox" class="k-checkbox" kendoCheckBox [formControl]="_printReceipt"
                                              />
                                          }
                                          @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                                            <div class="transactions-receive-stock-right-checkbox-text"
                                              >
                                              Print Receipt
                                            </div>
                                          }
                                        </div>
                                        <!-- <div
                                        *ngIf="_printLabelsEnabled"
                                        class="transactions-receive-stock-right-checkbox"
                                        >
                                        <div class="col-2 p-0">
                                          <input
                                            type="checkbox"
                                            class="k-checkbox"
                                            kendoCheckBox
                                            [formControl]="_printLabel"
                                            (change)="_checkLabel($event)"
                                            />
                                          </div>
                                          <div class="col-9 p-0">
                                            <div
                                              class="transactions-receive-stock-right-checkbox-text m-0"
                                              >
                                              Print Label
                                            </div>
                                          </div>

                                          <div *ngIf="_printLabel.value">
                                            <div class="labelQty">
                                              <input
                                                type="radio"
                                                class="adminRadio"
                                                name="label"
                                                kendoRadioButton
                                                style="width: 10px; height: 10px"
                                                [checked]="_isOneLineItem"
                                                value="line"
                                                (change)="_lineQtyChange($event)"
                                                />
                                                1/line item
                                              </div>
                                              <div class="labelQty">
                                                <input
                                                  type="radio"
                                                  class="adminRadio"
                                                  name="label"
                                                  kendoRadioButton
                                                  style="width: 10px; height: 10px"
                                                  [checked]="!_isOneLineItem"
                                                  value="qty"
                                                  (change)="_lineQtyChange($event)"
                                                  />
                                                  Qty/line item
                                                </div>
                                              </div>
                                            </div> -->
                                          <!-- </div> -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12">
                                  <div class="transactionWidget with-grid numericboxtab">
                                    <div class="flex-space-between transaction-receive-grid-header-wrapper">
                                      <p class="titleStandardStyle">Selected Items</p>
                                      <div class="transaction-receive-grid-top-actions">
                                        <div class="transaction-receive-grid-top-actions-radio">
                                          <input type="radio" id="new-to-old-items" name="transaction-receive-duration" value="new"
                                            [formControl]="_sortingSelected" kendoRadioButton />
                                            <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                                          </div>
                                          <div class="transaction-receive-grid-top-actions-radio">
                                            <input type="radio" id="old-to-new-items" name="transaction-receive-duration" value="old"
                                              [formControl]="_sortingSelected" kendoRadioButton />
                                              <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div style="overflow-x: scroll !important">
                                          <kendo-grid [data]="_inventoryGridData" [style.height.%]="100" class="transaction-receive-grid"
                                            (remove)="_removeHandler($event)">
                                            <kendo-grid-column field="itemNumber" title="Stock Item #" [width]="150">
                                            </kendo-grid-column>

                                            @if (_showVendorStockItemOnPOAndRece) {
                                              <kendo-grid-column field="vendorStockNumber" title="Vendor Stock Item #" [width]="150">
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                  {{ getVendorStockNumber(dataItem) }}
                                                </ng-template>
                                              </kendo-grid-column>
                                            }

                                            <kendo-grid-column field="itemType" title="Item Type" [width]="150">
                                            </kendo-grid-column>

                                            <kendo-grid-column field="description" title="Description" [width]="150">
                                            </kendo-grid-column>

                                            <kendo-grid-column field="quantity" title="Quantity" [width]="150">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                <kendo-numerictextbox class="transaction-receive-grid-quantity" [value]="dataItem.quantity"
                                                  format="{{ quantityFormat }}" (valueChange)="_onQuantityChange($event, dataItem)" [min]="0"
                                                  [max]="this._pomaxvalueusermustenter(dataItem)" [autoCorrect]="autoCorrect">
                                                </kendo-numerictextbox>
                                              </ng-template>
                                            </kendo-grid-column>

                                            <kendo-grid-column field="uom" title="Receive U/M" [width]="150">
                                            </kendo-grid-column>

                                            <kendo-grid-column field="inventoryCode" title="Inventory ID#" [width]="150">
                                              <ng-template style="width: 5rem !important" kendoGridCellTemplate let-dataItem>
                                                <asap-barcode-generation
                                                  [class.disabled]="dataItem.itemType === 'standard' || dataItem.itemType === 'non-inventory'"
                                                  class="transaction-grid-barcode-generator" [placeholder]="'Inventory ID#'"
                                                  [entityName]="'inventories'" [quantity]="dataItem.itemType === 'serial' ? dataItem.quantity : 1"
                                                  [value]="dataItem.inventoryCode" (valueChange)="_onInventoryCodeChange($event, dataItem)"
                                                  [icon]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                                                </asap-barcode-generation>
                                              </ng-template>
                                            </kendo-grid-column>

                                            <kendo-grid-column field="expirationDate" title="Expiration Date" [width]="170">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                <div class="display-flex">
                                                  <kendo-datetimepicker
                                                    [class.disabled]="dataItem.itemType === 'standard' || dataItem.itemType === 'non-inventory'"
                                                    [value]="dataItem.expirationDate" (valueChange)="_onExpirationDateChange($event, dataItem)"
                                                    placeholder="Choose Date and Time" [format]="_datePickerFormat">
                                                  </kendo-datetimepicker>
                                                  <!-- <span class="asap-input-icon input-icon-with-margin"><img class="addIcon"
                                                [src]="'/assets/menu/'+ _theme +'/time-schedule-report-icon.svg'"></span> -->
                                              </div>
                                            </ng-template>
                                          </kendo-grid-column>

                                          <kendo-grid-column field="unitCost" title="Unit Cost" [width]="150">
                                            <ng-template kendoGridCellTemplate let-dataItem>
                                              <kendo-numerictextbox class="transaction-receive-grid-unitCost" [(ngModel)]="dataItem.unitCost"
                                                [ngModelOptions]="{standalone: true}" [format]="_costFormat" (input)="_onUnitCostChange(dataItem)"
                                                [min]="0" [autoCorrect]="true">
                                              </kendo-numerictextbox>
                                            </ng-template>
                                          </kendo-grid-column>

                                          @if (_defaultLocationSettingEnabled) {
                                            <kendo-grid-column [width]="150" field="defaultLocation"
                                              title="Default Location">
                                            </kendo-grid-column>
                                          }

                                          @if (_hasFieldControlLicense && _receiveUDField1Show) {
                                            <kendo-grid-column [width]="150" field="uDField1"
                                              [title]="_receiveUDField1Name">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                <input type="text" class="k-textbox writebox"
                                                  (change)="_onUDFieldChange($event, dataItem, 'uDField1')" />
                                                </ng-template>
                                              </kendo-grid-column>
                                            }

                                            @if (_hasFieldControlLicense && _receiveUDField2Show) {
                                              <kendo-grid-column [width]="150" field="uDField2"
                                                [title]="_receiveUDField2Name">
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                  <input type="text" class="k-textbox writebox"
                                                    (change)="_onUDFieldChange($event, dataItem, 'uDField2')" />
                                                  </ng-template>
                                                </kendo-grid-column>
                                              }

                                              @if (_hasFieldControlLicense && _receiveUDField3Show) {
                                                <kendo-grid-column [width]="150" field="uDField3"
                                                  [title]="_receiveUDField3Name">
                                                  <ng-template kendoGridCellTemplate let-dataItem>
                                                    <input type="text" class="k-textbox writebox"
                                                      (change)="_onUDFieldChange($event, dataItem, 'uDField3')" />
                                                    </ng-template>
                                                  </kendo-grid-column>
                                                }

                                                @if (_hasFieldControlLicense && _receiveUDFieldDate1Show) {
                                                  <kendo-grid-column field="uDFieldDate1" [title]="_receiveUDFieldDate1Name"
                                                    [width]="150">
                                                    <ng-template kendoGridCellTemplate let-dataItem>
                                                      <div class="display-flex">
                                                        <kendo-datetimepicker placeholder="Choose Date and Time"
                                                          (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate1')" [format]="_datePickerFormat">
                                                        </kendo-datetimepicker>
                                                      </div>
                                                    </ng-template>
                                                  </kendo-grid-column>
                                                }

                                                @if (_hasFieldControlLicense && _receiveUDFieldDate2Show) {
                                                  <kendo-grid-column field="uDFieldDate2" [title]="_receiveUDFieldDate2Name"
                                                    [width]="150">
                                                    <ng-template kendoGridCellTemplate let-dataItem>
                                                      <div class="display-flex">
                                                        <kendo-datetimepicker placeholder="Choose Date and Time"
                                                          (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate2')" [format]="_datePickerFormat">
                                                        </kendo-datetimepicker>
                                                      </div>
                                                    </ng-template>
                                                  </kendo-grid-column>
                                                }

                                                @if (_hasFieldControlLicense && _receiveUDFieldDate3Show) {
                                                  <kendo-grid-column field="uDFieldDate3" [title]="_receiveUDFieldDate3Name"
                                                    [width]="150">
                                                    <ng-template kendoGridCellTemplate let-dataItem>
                                                      <div class="display-flex">
                                                        <kendo-datetimepicker placeholder="Choose Date and Time"
                                                          (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate3')" [format]="_datePickerFormat">
                                                        </kendo-datetimepicker>
                                                      </div>
                                                    </ng-template>
                                                  </kendo-grid-column>
                                                }

                                                <kendo-grid-command-column title="Action" [width]="150">
                                                  <ng-template kendoGridCellTemplate>
                                                    <div kendoGridRemoveCommand class="asap-grid-remove">
                                                      <div class="asap-grid-remove-icon">
                                                        <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                      </div>
                                                      <div class="asap-grid-remove-text">Delete</div>
                                                    </div>
                                                  </ng-template>
                                                </kendo-grid-command-column>
                                              </kendo-grid>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <!-- <div class="row">
                                      <div class="col-12">
                                        <asap-forms-validation-summary *ngIf="_invalidForm"
                                          [form]="_form"
                                          [page]="'receive'">
                                        </asap-forms-validation-summary>
                                      </div>
                                    </div> -->

                                    <div class="row">
                                      <div class="col-12">
                                        @if (_invalidavailableqty) {
                                          <asap-forms-validation-summary [form]="_form" [isrequird]="false"
                                            [additionalErrors]="_additionalErrors" [page]="'receive'">
                                          </asap-forms-validation-summary>
                                        }
                                      </div>
                                    </div>
                                  </form>

                                  @if (_isDialiog) {
                                    <asap-dialog-layout [componentName]="_dialogComponentName" [data]="_dialogModel"
                                      (closeDialog)="_closeDialog($event)">
                                    </asap-dialog-layout>
                                  }
                                  <!-- transaction-receive-grid -->
                                  <!-- barcode-generator-popup -->
                                  @if (_barcodePopupActive) {
                                    <kendo-window class="barcode-generator-popup" title="Barcode Management For Serial Items"
                                      (close)="_barcodePopupClose()">
                                      <form [formGroup]="_barcodePopupForm" class="form_style">
                                        <div class="col-12">
                                          <div class="row special_row_margin">
                                            <div class="col-12 special_col_padding">
                                              <div class="border_sections margin-top-4">
                                                <div class="k-block">
                                                  <h2>Inventory ID#</h2>
                                                  <div class="right_buttons">
                                                    <br />
                                                    <div class="row mx-0 bottom_buttons">
                                                      <!-- <button class="asap-btn" kendoButton (click)="_barcodePopupGenerateBarcode()">
                                                      Scan
                                                    </button> -->
                                                    <button class="asap-btn" kendoButton (click)="_onBarcodePopupClear()">
                                                      <span>
                                                        <img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
                                                      </span>Clear
                                                    </button>
                                                    <button class="asap-btn" kendoButton [disabled]="_barcodePopupForm.invalid"
                                                      (click)="_onBarcodePopupSave()">
                                                      <span>
                                                        <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
                                                      </span>Save
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="row row_padding">
                                                <div class="col-12">
                                                  @for (field of _barcodePopupFormFields; track field) {
                                                    <div class="form-group from_but_container special_style_formgroup display-flex mb-3">
                                                      <input type="text" class="k-textbox writebox" [placeholder]="'Inventory ID#'"
                                                        [formControlName]="field" />
                                                        <a class="cursor-pointer" (click)="_barcodePopupGenerateBarcode(field)">
                                                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                                        </a>
                                                        <a class="cursor-pointer ml-1" (click)="_onBarcodePopupClear(field)">
                                                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
                                                        </a>
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </kendo-window>
                                  }



                                  <!-- Vendor Select-->@if (_showVendorsGrid) {
                                  <kendo-window title="" (close)="_closeVendorsWindow()"
                                    class="addFromLibrary">
                                    <div class="greytabtop">
                                      <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedVendorsHandler($event)">
                                        Select & Return
                                      </button>
                                    </div>
                                    <asap-grid-layout [selectable]="true" [singleSelect]="true" [groupingEnabled]="true" [pagingEnabled]="true"
                                      [headerEnable]="true" [headerTitle]="''" [page]="'vendors'" [entityName]="'stock'" [addNewFormEnabled]="false"
                                      [orderEnable]="true" [deletedEnabled]="false" [selectByField]="'id'" [selectByFieldTitle]="''"
                                      [enableSiteSelection]="false" [filteringEnable]="true" [HideNotesFields]="true" [resolver]="_getVendors"
                                      (onRowSelectionChanges)="_onVendorRowSelectionChanges($event)">
                                      @for (column of _vendorsGridColumns; track column) {
                                        @if (column.selected) {
                                          @if (!column.isTemplate) {
                                            <ng-template pageListColumn [field]="column.field"
                                              [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                              let-item>
                                              @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                                {{ item[column.field] | dateFormat }}
                                              }
                                              @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                                @if (column.field != 'notes' && column.field !='site.code') {
                                                  <label>
                                                    {{column.field | complexFieldValue: item}}
                                                  </label>
                                                }
                                                @if (column.field =='site.code' || column.field =='site.name') {
                                                  <label>
                                                    {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                                  </label>
                                                }
                                              }
                                              @if (column.isCustomField == true) {
                                                {{item[column.field]}}
                                              }
                                            </ng-template>
                                          }
                                          @if (column.isTemplate) {
                                            <ng-template pageListColumn [field]="column.field"
                                              [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                              let-item>
                                              @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                                {{ item[column.field] | dateFormat }}
                                              }
                                              @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                                @if (column.field != 'notes' && column.field !='site.code' && column.field !='site.name') {
                                                  <label>
                                                    {{column.field | complexFieldValue: item}}
                                                  </label>
                                                }
                                                @if (column.field =='site.code' || column.field =='site.name') {
                                                  <label>
                                                    {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                                  </label>
                                                }
                                              }
                                              @if (column.isCustomField == true) {
                                                {{item[column.field]}}
                                              }
                                            </ng-template>
                                          }
                                        }
                                      }
                                    </asap-grid-layout>
                                  </kendo-window>
                                }
                                @if (false) {
                                  <kendo-window title="{{'Add Vendor to the Receive Transaction'}}" (close)="_closeVendorsWindow()"
                                    class="addFromLibrary">
                                    <div class="greytabtop">
                                      <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedVendorsHandler($event)">
                                        Select & Return
                                      </button>
                                    </div>
                                    @if (_vendorsGridColumns) {
                                      <asap-grid-layout [page]="'vendors'" [entityName]="'stock'" [sortingEnabled]="true"
                                        [enableSiteSelection]="false" [resolver]="_getVendors" [orderEnable]="true" class="ListGrid" [selectable]="true"
                                        [pagingEnabled]="true" [selectByField]="_selectedCallback" [filteringEnable]="true" [addNewFormEnabled]="false"
                                        [deletedEnabled]="false" [headerEnable]="true" [enableSiteSelection]="false" [singleSelect]="true"
                                        (onRowSelectionChanges)="_onVendorRowSelectionChanges($event)">
                                        @for (column of _vendorsGridColumns; track column) {
                                          @if (column.selected) {
                                            @if (column.isTemplate) {
                                              <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type" let-item>
                                              </ng-template>
                                            }
                                            @if (!column.isTemplate) {
                                              <!-- <ng-template
                                              pageListColumn
                                              [field]="column.field"
                                              [name]="column.gridFieldText?.currentText??column.title"
                                              [type]="column.type"
                                              let-item
                                              >
                                              <ng-container *ngIf="column.type === 'date'  ">
                                                {{item[column.field] !== undefined || item[column.field] !== null ? ( item[column.field] | dateFormat )
                                                : '' }}
                                              </ng-container>
                                              <ng-container *ngIf="column.type != 'date' || column.type === null ">
                                                {{ item[column.field] !== undefined || item[column.field] !== null ? item[column.field] : '' }}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type == 'date' && column.field.split('.').length  == 2"
                                                >
                                                {{item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                null ? (item[column.field?.split('.')[0]]
                                                [column.field?.split('.')[1]] | dateFormat ): '' }}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type == 'date' && column.field?.split('.').length  == 3"
                                                >
                                                {{item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                !== null && item[column.field?.split('.')[0]]
                                                [column.field?.split('.')[1]][column.field?.split('.')[2]] !== null?
                                                (item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                [column.field?.split('.')[2]] | dateFormat ) : '' }}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type != 'date' &&  column.field.split('.').length  == 2"
                                                >
                                                {{item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                : '' }}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type != 'date' && column.field.split('.').length == 3 "
                                                >
                                                {{item[column.field] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
                                                null && item[column.field?.split('.')[0]]
                                                [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
                                                ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                [column.field?.split('.')[2]] : ''}}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type != 'date'  && column.type != 'image' &&  column.field.split('.').length  == 2"
                                                >
                                                {{item[column.field?.split('.')[0]] !== null &&
                                                item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                : '' }}
                                              </ng-container>
                                              <ng-container
                                                *ngIf="column.type != 'date'  && column.type != 'image' && column.field.split('.').length == 3 "
                                                >
                                                {{item[column.field?.split('.')[0]] !== null &&
                                                item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
                                                null && item[column.field?.split('.')[0]]
                                                [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
                                                ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                [column.field?.split('.')[2]] : ''}}
                                              </ng-container>
                                              <ng-container  *ngIf="column.type == 'image' &&  column.field.split('.').length  == 2" >
                                                <div class="CellimageThumnail" *ngIf="item.file.thumbnail != undefined">
                                                  <img
                  [src]="item.file.thumbnail != null ? imageUrl( item[column.field?.split('.')[0]] !== null &&
              item[column.field.split('.')[0]][column.field.split('.')[1]] !==
              null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
              : '') : '' "
                                                    width="100" />
                                                  </div>
                                                </ng-container>
                                                <ng-container  *ngIf="column.type == 'image' &&  column.field.split('.').length  == 3" >
                                                  <div class="CellimageThumnail" *ngIf="item.file.thumbnail != undefined">
                                                    <img
                  [src]="imageUrl( item[column.field?.split('.')[0]] !== null &&
              item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
              null && item[column.field?.split('.')[0]]
              [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
              ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
              [column.field?.split('.')[2]] : '')"
                                                      width="100" />
                                                    </div>
                                                  </ng-container>
                                                </ng-template> -->
                                                <ng-template pageListColumn [field]="column.field" [name]="column.gridFieldText?.currentText??column.title"
                                                  [type]="column.type" let-item>
                                                  @if (column.type === 'date') {
                                                    {{
                                                    item[column.field] !== null ? ( item[column.field] | dateFormat )
                                                    : ''
                                                    }}
                                                  }
                                                  @if (column.type != 'date' && column.type != 'image') {
                                                    {{ item[column.field] != null ? item[column.field] : '' }}
                                                  }
                                                  @if (column.type == 'date' && column.field.split('.').length  == 2) {
                                                    {{
                                                    item[column.field?.split('.')[0]] != null &&
                                                    item[column.field.split('.')[0]][column.field.split('.')[1]] !=
                                                    null ? (item[column.field?.split('.')[0]]
                                                    [column.field?.split('.')[1]] | dateFormat ): ''
                                                    }}
                                                  }
                                                  @if (column.type == 'date' && column.field?.split('.').length  == 3) {
                                                    {{
                                                    item[column.field?.split('.')[0]] != null && item[column.field?.split('.')[0]]
                                                    [column.field?.split('.')[1]]
                                                    != null && item[column.field?.split('.')[0]]
                                                    [column.field?.split('.')[1]][column.field?.split('.')[2]] != null?
                                                    (item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                    [column.field?.split('.')[2]] | dateFormat ) : ''
                                                    }}
                                                  }
                                                  @if (column.type != 'date'  && column.type != 'image' &&  column.field.split('.').length  == 2) {
                                                    {{
                                                    item[column.field?.split('.')[0]] !== null &&
                                                    item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                    null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                    : ''
                                                    }}
                                                  }
                                                  @if (column.type != 'date'  && column.type != 'image' && column.field.split('.').length == 3 ) {
                                                    {{
                                                    item[column.field?.split('.')[0]] !== null &&
                                                    item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
                                                    null && item[column.field?.split('.')[0]]
                                                    [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
                                                    ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                    [column.field?.split('.')[2]] : ''
                                                    }}
                                                  }
                                                  @if (column.type == 'image' &&  column.field.split('.').length  == 2) {
                                                    @if (item?.file?.thumbnail != undefined) {
                                                      <div class="CellimageThumnail">
                <img [src]="item?.file?.thumbnail != null ? imageUrl( item[column.field?.split('.')[0]] !== null &&
            item[column.field.split('.')[0]][column.field.split('.')[1]] !==
            null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
            : '') : '' " width="100" />
                                                        </div>
                                                      }
                                                    }
                                                    @if (column.type == 'image' &&  column.field.split('.').length  == 3) {
                                                      @if (item?.file?.thumbnail != undefined) {
                                                        <div class="CellimageThumnail">
                <img [src]="imageUrl( item[column.field?.split('.')[0]] !== null &&
            item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
            null && item[column.field?.split('.')[0]]
            [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
            ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
            [column.field?.split('.')[2]] : '')" width="100" />
                                                          </div>
                                                        }
                                                      }
                                                    </ng-template>
                                                  }
                                                }
                                              }
                                            </asap-grid-layout>
                                          }
                                        </kendo-window>
                                      }


                                      <!-- Stock Items Select-->
                                      @if (_showStocksGrid) {
                                        <kendo-window title="{{'Add Stock to the Receive Transaction'}}" (close)="_closeStocksWindow()"
                                          class="addFromLibrary">
                                          <div class="greytabtop">
                                            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedStocksHandler($event)">
                                              Select & Return
                                            </button>
                                          </div>
                                          @if (_stockItemsGridColumns) {
                                            <asap-grid-layout [page]="'stockItems'" [entityName]="'stock'" [sortingEnabled]="true"
                                              [enableSiteSelection]="false" [resolver]="_getStockItems" class="ListGrid" [orderEnable]="true" [selectable]="true"
                                              [pagingEnabled]="true" [selectByField]="_selectedCallback" [filteringEnable]="true" [addNewFormEnabled]="false"
                                              [deletedEnabled]="false" [headerEnable]="true" [enableSiteSelection]="false"
                                              (onRowSelectionChanges)="_onStockRowSelectionChanges($event)">
                                              @for (column of _stockItemsGridColumns; track column) {
                                                @if (column.selected) {
                                                  @if (column.isTemplate) {
                                                    <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type" let-item>
                                                      @if (column.field == 'costInfo.cost') {
                                                        {{$safeNavigationMigration(item.costInfo?.cost) | costFormat}}
                                                      }
                                                      @if (column.field == 'costInfo.markupPercent') {
                                                        {{$safeNavigationMigration(item.costInfo?.markupPercent) | costFormat}}
                                                      }
                                                      @if (column.field == 'costInfo.markupNumber') {
                                                        {{$safeNavigationMigration(item.costInfo?.markupNumber) | costFormat}}
                                                      }
                                                      @if (column.field =='site.code' || column.field == 'site.name') {
                                                        {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                                      }
                                                    </ng-template>
                                                  }
                                                  @if (!column.isTemplate) {
                                                    <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type" let-item>
                                                      @if (column.type === 'date') {
                                                        {{
                                                        item[column.field] !== null ? ( item[column.field] | dateFormat )
                                                        : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date') {
                                                        {{ item[column.field] != null ? item[column.field] : '' }}
                                                      }
                                                      @if (column.type == 'date' && column.field.split('.').length  == 2) {
                                                        {{
                                                        item[column.field?.split('.')[0]] != null &&
                                                        item[column.field.split('.')[0]][column.field.split('.')[1]] !=
                                                        null ? (item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]] | dateFormat ): ''
                                                        }}
                                                      }
                                                      @if (column.type == 'date' && column.field?.split('.').length  == 3) {
                                                        {{
                                                        item[column.field?.split('.')[0]] != null && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]]
                                                        != null && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]][column.field?.split('.')[2]] != null?
                                                        (item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                        [column.field?.split('.')[2]] | dateFormat ) : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date' &&  column.field.split('.').length  == 2) {
                                                        {{
                                                        item[column.field?.split('.')[0]] != null &&
                                                        item[column.field.split('.')[0]][column.field.split('.')[1]] !=
                                                        null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                        : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date' && column.field.split('.').length == 3 ) {
                                                        {{
                                                        item[column.field] != null && item[column.field?.split('.')[0]] != null &&
                                                        item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !=
                                                        null && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]] [column.field?.split('.')[2]] != null
                                                        ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                        [column.field?.split('.')[2]] : ''
                                                        }}
                                                      }
                                                    </ng-template>
                                                  }
                                                }
                                              }
                                            </asap-grid-layout>
                                          }
                                        </kendo-window>
                                      }

                                      <!-- Locations Select-->
                                      @if (_showLocationsGrid) {
                                        <kendo-window title="" (close)="_closeLocationsWindow()" class="addFromLibrary">
                                          <div class="greytabtop">
                                            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedLocationsHandler($event)">
                                              Select & Return
                                            </button>
                                          </div>
                                          <asap-grid-layout [selectable]="true" [singleSelect]="true" [groupingEnabled]="true" [pagingEnabled]="true"
                                            [headerEnable]="true" [headerTitle]="''" [entityName]="'location'" [addNewFormEnabled]="false" [orderEnable]="true"
                                            [page]="'locations'" [deletedEnabled]="false" [selectByField]="'id'" [selectByFieldTitle]="''"
                                            [enableSiteSelection]="false" [filteringEnable]="true" [HideNotesFields]="true" [resolver]="_getLocations"
                                            (onRowSelectionChanges)="_onLocationRowSelectionChanges($event)">
                                            @for (column of _locationsGridColumns; track column) {
                                              @if (column.selected) {
                                                @if (!column.isTemplate) {
                                                  <ng-template pageListColumn [field]="column.field"
                                                    [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                                    let-item>
                                                    @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                                      {{ item[column.field] | dateFormat }}
                                                    }
                                                    @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                                      @if (column.field != 'notes' && column.field !='site.code') {
                                                        <label>
                                                          {{column.field | complexFieldValue: item}}
                                                        </label>
                                                      }
                                                      @if (column.field =='site.code') {
                                                        <label>
                                                          {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                                        </label>
                                                      }
                                                    }
                                                    @if (column.isCustomField == true) {
                                                      {{item[column.field]}}
                                                    }
                                                  </ng-template>
                                                }
                                                @if (column.isTemplate) {
                                                  <ng-template pageListColumn [field]="column.field"
                                                    [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                                    let-item>
                                                    @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                                      {{ item[column.field] | dateFormat }}
                                                    }
                                                    @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                                      @if (column.field != 'notes' && column.field !='site.code') {
                                                        <label>
                                                          {{column.field | complexFieldValue: item}}
                                                        </label>
                                                      }
                                                      @if (column.field =='site.code') {
                                                        <label>
                                                          {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                                        </label>
                                                      }
                                                    }
                                                    @if (column.isCustomField == true) {
                                                      {{item[column.field]}}
                                                    }
                                                  </ng-template>
                                                }
                                              }
                                            }
                                          </asap-grid-layout>
                                        </kendo-window>
                                      }
                                      @if (false) {
                                        <kendo-window title="{{'Add Location to the Receive Transaction'}}" (close)="_closeLocationsWindow()"
                                          class="addFromLibrary">
                                          <div class="greytabtop">
                                            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedLocationsHandler($event)">
                                              Select & Return
                                            </button>
                                          </div>
                                          @if (_locationsGridColumns) {
                                            <asap-grid-layout [page]="'locations'" [entityName]="'location'" [sortingEnabled]="true"
                                              [enableSiteSelection]="false" [resolver]="_getLocations" [orderEnable]="true" class="ListGrid" [selectable]="true"
                                              [pagingEnabled]="true" [selectByField]="_selectedCallback" [filteringEnable]="true" [addNewFormEnabled]="false"
                                              [deletedEnabled]="false" [headerEnable]="true" (onRowSelectionChanges)="_onLocationRowSelectionChanges($event)"
                                              [singleSelect]="true">
                                              @for (column of _locationsGridColumns; track column) {
                                                @if (column.selected) {
                                                  @if (column.isTemplate) {
                                                    <ng-template pageListColumn [field]="column.field" [name]="column.gridFieldText?.currentText??column.title"
                                                      [type]="column.type" let-item>
                                                    </ng-template>
                                                  }
                                                  @if (!column.isTemplate) {
                                                    <ng-template pageListColumn [field]="column.field" [name]="column.gridFieldText?.currentText??column.title"
                                                      [type]="column.type" let-item>
                                                      @if (column.type === 'date'  ) {
                                                        {{
                                                        item[column.field] !== undefined || item[column.field] !== null ? ( item[column.field] | dateFormat )
                                                        : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date' || column.type === null ) {
                                                        {{ item[column.field] !== undefined || item[column.field] !== null ? item[column.field] : '' }}
                                                      }
                                                      @if (column.type == 'date' && column.field.split('.').length  == 2) {
                                                        {{
                                                        item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                        item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                        null ? (item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]] | dateFormat ): ''
                                                        }}
                                                      }
                                                      @if (column.type == 'date' && column.field?.split('.').length  == 3) {
                                                        {{
                                                        item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]]
                                                        !== null && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]][column.field?.split('.')[2]] !== null?
                                                        (item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                        [column.field?.split('.')[2]] | dateFormat ) : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date' &&  column.field.split('.').length  == 2) {
                                                        {{
                                                        item[column.field?.split('.')[0]] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                        item[column.field.split('.')[0]][column.field.split('.')[1]] !==
                                                        null ? item[column.field.split('.')[0]][column.field.split('.')[1]]
                                                        : ''
                                                        }}
                                                      }
                                                      @if (column.type != 'date' && column.field.split('.').length == 3 ) {
                                                        {{
                                                        item[column.field] !== undefined && item[column.field?.split('.')[0]] !== null &&
                                                        item[column.field?.split('.')[0]] [column.field?.split('.')[1]] !==
                                                        null && item[column.field?.split('.')[0]]
                                                        [column.field?.split('.')[1]] [column.field?.split('.')[2]] !== null
                                                        ? item[column.field?.split('.')[0]] [column.field?.split('.')[1]]
                                                        [column.field?.split('.')[2]] : ''
                                                        }}
                                                      }
                                                    </ng-template>
                                                  }
                                                }
                                              }
                                            </asap-grid-layout>
                                          }
                                        </kendo-window>
                                      }

                                      @if (showReports) {
                                        <kendo-window [width]="750" (close)="closeReport()" (keydown.enter)="$event.preventDefault()">
                                          <div class="col-12 form-group ps-4">
                                            <div style="margin-top: 10px;  margin-right: 5px;">
                                              <button (click)="closeReport()" kendoButton class="steps_buttons_class">
                                                <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                                <span>close</span>
                                              </button>
                                              <button (click)="_printReceiptReport()" kendoButton class="steps_buttons_class">
                                                <span><img class="backimage" [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>Print
                                              </button>
                                            </div>
                                            <label class="control-label trl" style="margin-top: 15px;">Receive Receipt</label>
                                            <kendo-combobox #kendo_combo_Receipt_Report [data]="receiveReports" [suggest]="true"
                                              class="bordered newFormControlWidth" [textField]="'name'" [valueField]="'id'"
                                              placeholder="Select Receive Print Receipt">
                                            </kendo-combobox>
                                          </div>
                                        </kendo-window>
                                      }

                                      @if (_editFormActive) {
                                        <kendo-window
                                          title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record ' +_selectedLabelText : '')) }}"
                                          (close)="_closeCustomFields()" class="customFieldsWindow">
                                          <asap-custom-fields [accounts]="_selectedAccountIds" [labelObjectCode]="_selectedLabelObjectCode" [formName]="'stock'"
                                            [page]="_page" [isCustomfieldsForm]="_isCustomfieldsFormValue" [isCustomtabsForm]="_isAddTabFormValue"
                                            [isRenameForm]="_isRenameFormValue" [language]="_language" [isRenameCustomForm]="_isRenameCustomFormValue"
                                            [onlyRequired]="_onlyRequired" [hasRequired]="_hasRequired" [isRenameLabel]="_isRenameLabel"
                                            [isMandatory]="_isMandatory" [isTransaction]="_isTransaction" (closePopup)="ClosePopup($event)"
                                            [permissionScope]="'adjust-transactions'">
                                          </asap-custom-fields>
                                        </kendo-window>
                                      }
                                      @if (_previewWindow) {
                                        <kendo-window class="big-index" (close)="_closeBarcodeForm()">
                                          <barcode-report-viewer [barcodeModel]="_barcodemodel" [windowMode]="windowMode" [previewMode]="true"
                                            style="z-index: 19999 !important;">
                                          </barcode-report-viewer>
                                        </kendo-window>
                                      }

                                      @if (_showDocumentsGrid) {
                                        <kendo-window title="Add Document(s) to Receive Transaction"
                                          (close)="_closeDocumentsWindow()" class="addFromLibrary">
                                          <div class="greytabtop">
                                            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedDocumentsHandler($event)">
                                              Select & Return
                                            </button>
                                          </div>
                                          <asap-grid-layout [selectable]="true" [pagingEnabled]="true" [selectByField]="'id'"
                                            [selectByFieldTitle]="'Select Document'" [enableSiteSelection]="false" [filteringEnable]="true"
                                            [selectedKeys]="_selectedDocumentsKeys" [resolver]="_getAccountDocuments" [orderEnable]="true"
                                            [sortingEnabled]="true" (onRowSelectionChanges)="_onDocumentRowSelectionChanges($event)"
                                            (onRowObjectSelectionChanges)="_onDocumentbjectRowSelectionChanges($event)">
                                            <ng-template pageListColumn name="Name" field="name" let-item>
                                              {{item.name}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Description" field="description" let-item>
                                              {{item.description}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Type" field="type" let-item>
                                              {{item.type}}
                                            </ng-template>
                                            <ng-template pageListColumn name="Stream" let-item>
                                              <img src="{{ item.stream }}" alt="{{ item.name }}" width="50" />
                                            </ng-template>
                                          </asap-grid-layout>
                                        </kendo-window>
                                      }
                                      @if (_showStocksGrid || _barcodePopupActive || showReports || _showLocationsGrid || _showVendorsGrid
                                        || _showDocumentsGrid || _previewWindow || _editFormActive) {
                                        <div class="k-overlay"></div>
                                      }